import {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {changePaymentMethod} from 'desktop/pages/checkout/store/reducers/paymentStep/paymentMethods/paymentMethods';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

/**
 * Update payment method
 */
export const useUpdatePaymentMethod = () => {
    const {selectedPaymentMethod} = useIsOneStepAvailable();

    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedPaymentMethod) {
            dispatch(changePaymentMethod(selectedPaymentMethod as PAYMENTS));
        }
    }, [dispatch, selectedPaymentMethod]);
};
